/// <reference path="./draw.d.ts" />
import { PageGen, PdfFont, PdfBrush, PdfRect, PdfSize, ETextAlign } from '../pdf';
import { parseLatex } from './parser';
import { layoutNode } from './layout';
import { LayoutCtx } from './types';

PageGen.prototype.measureLatex = function (
  this: PageGen,
  latex: string,
  fontSize: number
): PdfSize {
  const ctx = makeCtx(this, fontSize, true);
  const box = layoutNode(parseLatex(latex), ctx);
  return new PdfSize(box.width, box.height + box.depth);
};

PageGen.prototype.drawLatex = function (
  this: PageGen,
  latex: string,
  rect: PdfRect,
  align: ETextAlign,
  fontSize: number,
  brush: PdfBrush = PdfBrush.Black,
  displayStyle = false
): void {
  const ctx = makeCtx(this, fontSize, displayStyle);
  const box = layoutNode(parseLatex(latex), ctx);

  // Horizontal
  let x: number;
  switch (align) {
    case ETextAlign.TopCenter:
    case ETextAlign.Center:
    case ETextAlign.BottomCenter:
      x = rect.left + (rect.width - box.width) / 2;
      break;
    case ETextAlign.TopRight:
    case ETextAlign.CenterRight:
    case ETextAlign.BottomRight:
      x = rect.right - box.width;
      break;
    default:
      x = rect.left;
  }

  // Vertical
  let baselineY: number;
  switch (align) {
    case ETextAlign.TopLeft:
    case ETextAlign.TopCenter:
    case ETextAlign.TopRight:
      baselineY = rect.top + box.height;
      break;
    case ETextAlign.BottomLeft:
    case ETextAlign.BottomCenter:
    case ETextAlign.BottomRight:
      baselineY = rect.bottom - box.depth;
      break;
    default:
      baselineY = rect.top + rect.height / 2 + (box.height - box.depth) / 2;
  }

  box.draw(this, x, baselineY, brush);
};

function makeCtx(page: PageGen, fontSize: number, displayStyle: boolean): LayoutCtx {
  return {
    regularFont: page.pdf.getFont(PdfFont.FONT_NAME),
    italicFont: page.pdf.getFont(PdfFont.ITALIC_FONT_NAME),
    size: fontSize,
    level: 0,
    displayStyle,
  };
}
